import React from "react"
import {message} from "antd"
import {autobind} from "core-decorators"
import createLanguage, {langPropTypes} from "hoc/create-lang"
import {get as _get} from "lodash"
import {REACHED_MAX_USERS} from "constants/error.js"

const createManagerEdit = ({apiUpdate, apiGetByKey}) => (Component) => {
  @createLanguage
  @autobind
  class ManagerEditHoc extends React.Component {
    state = {
      isLoaded: false,
      data: {},
    }
    static propTypes = {
      lang: langPropTypes,
    }
    async updateItem(data, callback) {
      const key = this.props.match.params.key
      const res = await apiUpdate(key, data)
      if (res.success) {
        message.info(this.props.lang.t("addon.onSave.update.success"))
      } else {
        const keyMessage = _get(res, "message")
        const info = _get(res, "info")

        switch (keyMessage) {
          case REACHED_MAX_USERS: {
            const mess = this.props.lang.t("error.reachedMaxUsers", {
              totalUser: _get(info, "totalUser",0)
            })
            message.error(mess)
            break
          }
          default: {
            message.error(this.props.lang.t("addon.onSave.update.error"))
          }
        }
      }
      if (callback) callback(res)
    }

    //Su kien truoc khi component duoc tao ra
    async getItem() {
      const key = this.props.match.params.key
      const item = await apiGetByKey(key)
      if (item.success) this.setState({isLoaded: true, data: item.data})
      else {
        message.error(this.props.lang.t("addon.onSave.update.error"))
      }
    }

    render() {
      const props = {
        isLoaded: this.state.isLoaded,
        data: this.state.data,
        onUpdateItem: this.updateItem,
        getItem: this.getItem,
      }
      return <Component {...this.props} {...props} />
    }
  }
  return ManagerEditHoc
}
export default createManagerEdit



// WEBPACK FOOTER //
// ./src/hoc/manager-edit/index.js